import moment from 'moment'
import JSFileDownloader from 'js-file-downloader'

export const isDev = process.env.NODE_ENV === 'development'

export const round = (value, decimals) =>
  Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)

export const getFullName = ({ first_name, last_name, username }) =>
  first_name && last_name ? `${last_name} ${first_name}` : username

export const getNameInitials = ({ last_name, first_name, username }) =>
  first_name && last_name
    ? `${last_name[0].toUpperCase()}${first_name[0].toUpperCase()}`
    : username[0].toUpperCase()

export const isMatching = (full, str) => {
  if (!full) full = ''

  return full.toLowerCase().indexOf(str.toLowerCase()) > -1
}

export const getContractStatusColor = status => {
  switch (status) {
    case 'Активен':
      return 'geekblue'
    case 'Активен (ГГЭ)':
      return 'purple'
    case 'Активен (суд)':
      return 'volcano'
    case 'Завершен (ГУ)':
    case 'Завершен (долг З)':
    case 'Завершен (долг П)':
      return 'gold'
    case 'Завершен':
      return 'green'
    default:
      return 'default'
  }
}

export const getActStatusColor = status => {
  switch (status) {
    case 'На согласовании в компании':
      return 'purple'
    case 'Подписан':
      return 'geekblue'
    case 'Оплачен':
      return 'green'
    default:
      return 'default'
  }
}

export const getLawCaseStatusColor = status => {
  switch (status) {
    case 'Завершено':
      return 'green'
    case 'Активно':
      return 'geekblue'
    default:
      return 'default'
  }
}

export const getProcedureStatusColor = status => {
  switch (status) {
    case 'Отправлен запрос':
      return 'geekblue'
    case 'Получен':
      return 'green'
    default:
      return 'default'
  }
}

export const getBgStatusColor = status => {
  switch (status) {
    case 'open':
      return 'geekblue'
    case 'closed':
      return 'green'
    default:
      return 'default'
  }
}

export const getFormattedCosts = (costs = 0, noTip, withVat) => {
  if (costs === null) costs = 0

  const result = `${costs
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}`.replace('.', ',')
  const tip = withVat ? 'руб. с НДС' : 'руб. без НДС'

  if (noTip) return result

  return `${result} ${tip}`
}

export const formatDefaultDate = date =>
  moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
export const formatDate = (date, format) => moment(date, format).format()
export const parseDateToServer = date =>
  date
    ? typeof date === 'string'
      ? moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD')
      : moment(date.toISOString()).format('YYYY-MM-DD')
    : null
export const parseDate = date => moment(date).format('DD.MM.YYYY')
export const parseDateTime = date => moment(date).format('DD.MM.YYYY HH:mm')
export const isDatesNotValid = ({ start_date, end_date }) => {
  if (!start_date || !end_date) return false

  const start = moment(start_date, 'DD.MM.YYYY').unix()
  const end = moment(end_date, 'DD.MM.YYYY').unix()

  return end - start < 0
}

export const getLagLabel = value => {
  if (value === '-') {
    return '-'
  }

  if (value) {
    return `${value} дн.`
  }

  return ''
}

export const isRoadmapInvalid = r =>
  !r.number ||
  !r.name ||
  !r.start_date ||
  !r.end_date ||
  (!r.costs && r.costs !== 0) ||
  isDatesNotValid(r)

export const getDataFromLS = (name, data) =>
  localStorage.getItem(name) ? JSON.parse(localStorage.getItem(name)) : data

export const saveDataToLS = (name, data) =>
  localStorage.setItem(name, JSON.stringify(data))

export const getDataFromSS = (name, data) =>
  sessionStorage.getItem(name)
    ? JSON.parse(sessionStorage.getItem(name))
    : data
export const saveDataToSS = (name, data) =>
  sessionStorage.setItem(name, JSON.stringify(data))

export const removeBreakLines = str => str.replace(/(\r\n|\n|\r)/gm, '')

export const downloadFile = url => {
  const link = document.createElement('a')
  link.setAttribute('download', true)
  link.setAttribute('href', removeBreakLines(url))
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadWithWidget = (component, url) => {
  const process = event => {
    const { loaded } = event

    if (component.downloading) {
      component.downloading = false
      component.downloadModal = false
      component.$store.commit('SET_DOWNLOAD_FIELD', {
        field: 'loading',
        value: true
      })
    }

    component.$store.commit('SET_DOWNLOAD_FIELD', {
      field: 'loaded',
      value: Math.floor(loaded / 1024 / 1024)
    })
  }

  new JSFileDownloader({
    url,
    process,
    filename: 'Документы_offers.zip'
  })
    .then(() => {
      component.$store.commit('SET_DOWNLOAD_FIELD', {
        field: 'loading',
        value: false
      })
    })
    .catch(() => {
      component.$store.commit('SET_DOWNLOAD_FIELD', {
        field: 'loading',
        value: false
      })

      component.$Message.error({
        title: 'Ошибка при скачивании',
        desc: 'Не удалось скачать файл. Повторите попытку'
      })
    })
}

export const hexToRgbA = (hex, theme) => {
  const alpha = theme === 'light' ? ', 0.05' : ', 0.15'
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = '0x' + c.join('')
    return (
      'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + alpha
    )
  }
  throw new Error('Bad Hex')
}
export const colorPresets = [
  '#ffadd2',
  '#722ed1',
  '#f5222d',
  '#ffbb96',
  '#ffd591',
  '#faad14',
  '#fffb8f',
  '#a0d911',
  '#52c41a',
  '#87e8de',
  '#91d5ff',
  '#adc6ff'
]

export const toggleTheme = (newTheme = 'light') => {
  const oldClass = newTheme === 'dark' ? 'light' : 'dark'

  saveDataToLS('theme', newTheme)

  document.body.classList.remove(oldClass)
  document.body.classList.add(newTheme)
}

const getRowValue = (r, prop) => (r.is_retention ? 0 : r[prop])
export const getSummaryRow = ({ columns, data }, indexes, prop) => {
  const sums = {}

  columns.forEach((column, index) => {
    const key = column.key
    if (index === 1) {
      sums[key] = {
        key,
        value: 'ИТОГО'
      }
      return
    }
    if (indexes.includes(index)) {
      const sum = data.reduce(
        (prev, r) => prev + getRowValue(r, prop || key),
        0
      )

      sums[key] = {
        key,
        value: getFormattedCosts(sum, true, true)
      }
      return
    }

    sums[key] = {
      key,
      value: null
    }
  })

  return sums
}

export const costsFormatter = value =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
export const costsParser = value => value.replace(/\$\s?|(\s*)/g, '')

export const isValidEmail = email => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return regex.test(email)
}

export const checkDigitalInput = event => {
  if (
    !event.ctrlKey &&
    !event.metaKey &&
    !event.altKey &&
    !event.key.match(/^[0-9]$/) &&
    event.key !== 'Backspace' &&
    event.key !== 'Delete' &&
    event.key !== 'ArrowLeft' &&
    event.key !== 'ArrowRight' &&
    event.key !== 'Home' &&
    event.key !== 'End' &&
    event.key !== 'Tab'
  ) {
    return true
  }
}

export const isEditedContract = contract => {
  const fields = Object.keys(contract)

  return fields.some(f => {
    const value = contract[f]
    const type = typeof value

    if (f === 'contract_status_id') return false
    if (f === 'contract_type') return false

    switch (type) {
      case 'string':
        if (value) return true
        break
      case 'object':
        if (value && value.length) return true
        break
      default:
        return false
    }

    return false
  })
}

export const modifyRoadmapsDates = roadmaps =>
  roadmaps.map(r => ({
    ...r,
    start_date: moment(r.start_date, 'DD.MM.YYYY').format(),
    end_date: moment(r.end_date, 'DD.MM.YYYY').format()
  }))

export function getActualHeight () {
  const actualHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight ||
    document.body.offsetHeight

  return actualHeight
}

export const getPreviuosMonthDate = () => {
  const previousMonth = new Date()
  previousMonth.setDate(1)
  previousMonth.setMonth(previousMonth.getMonth() - 1)

  return previousMonth
}

export const getLastDayOfMonth = date => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export const modifyComplexData = (data, prop, idProp) => {
  data[prop] = data[prop].map(id => ({
    [idProp]: id
  }))
}

export const getNewComplexValues = (current, initial, prop) => {
  const newValues = current.map(value => {
    const initialValue = initial.find(t => t[prop] === value)

    return {
      id: initialValue ? initialValue.id : undefined,
      [prop]: value
    }
  })

  initial.forEach(t => {
    const modified = newValues.find(type => type.id === t.id)

    if (!modified) {
      newValues.push({
        id: t.id,
        disabled: true
      })
    }
  })

  return newValues
}
